import { render, staticRenderFns } from "./veStuPunishEdit.vue?vue&type=template&id=62b5b5e1&scoped=true"
import script from "./veStuPunishEdit.vue?vue&type=script&lang=js"
export * from "./veStuPunishEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5b5e1",
  null
  
)

export default component.exports